import { css } from 'lit';

export const DxoStyles = css`
    .grv-table {
        font-family: Optimist, "Helvetica Neue", Helvetica, Arial, sans-serif;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-size: 16px;
        line-height: 1.5;
        font-weight: 400;
        border-spacing: 0;
        color: #141414;
        font-variant-numeric: tabular-nums;
        text-align: left;
        width: 100%;
    }
    .grv-table__caption {
        text-align: left;
        margin-bottom: 8px;
    }
    .grv-table__row {
        padding: 0;
    }
    .grv-table__head .grv-table__header {
        text-align: left;
        text-transform: uppercase;
        font-family: Optimist, "Helvetica Neue", Helvetica, Arial, sans-serif;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-size: 16px;
        line-height: 1.5;
        font-weight: 600;
        padding: 16px 8px 8px;
        vertical-align: top;
    }
    .grv-table__head .grv-table__header:first-child {
        padding-left: 0;
    }
    .grv-table__head .grv-table__header:last-child {
        padding-right: 0;
    }
    .grv-table__head .grv-table__header--right-align {
        text-align: right;
    }
    .grv-table__head .grv-table__header--center-align {
        text-align: center;
    }
    .grv-table__head .grv-table__header--left-align {
        text-align: left;
    }
    .grv-table__body {
        font-family: Optimist, "Helvetica Neue", Helvetica, Arial, sans-serif;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-size: 16px;
        line-height: 1.5;
        font-weight: 400;
    }
    .grv-table__body .grv-table__header {
        text-align: left;
        text-transform: uppercase;
        padding: 16px 8px;
        border: 0;
        border-top: 1px solid #d4d4d4;
        margin: 16px 0;
    }
    .grv-table__body .grv-table__header:first-child {
        padding-left: 0;
    }
    .grv-table__body .grv-table__header:last-child {
        padding-right: 0;
    }
    .grv-table__body .grv-table__header--right-align {
        text-align: right;
    }
    .grv-table__body .grv-table__header--center-align {
        text-align: center;
    }
    .grv-table__body .grv-table__header--left-align {
        text-align: left;
    }
    .grv-table__body .grv-table__row:last-child .grv-table__cell,
    .grv-table__body .grv-table__row:last-child .grv-table__header {
        border-bottom: 1px solid #d4d4d4;
    }
    .grv-table__cell {
        padding: 16px 8px;
        border: 0;
        border-top: 1px solid #d4d4d4;
        margin: 16px 0;
        text-align: left;
        vertical-align: top;
        overflow-wrap: break-word;
        min-width: 80px;
    }
    .grv-table__cell:first-child {
        padding-left: 0;
    }
    .grv-table__cell:last-child {
        padding-right: 0;
    }
    .grv-table__cell--right-align {
        text-align: right;
    }
    .grv-table__cell--center-align {
        text-align: center;
    }
    .grv-table__cell--left-align {
        text-align: left;
    }
    .grv-table--small .grv-table__header {
        text-align: left;
        text-transform: uppercase;
        font-family: Optimist, "Helvetica Neue", Helvetica, Arial, sans-serif;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-size: 14px;
        line-height: 1.5;
        font-weight: 600;
        padding: 16px 8px 8px;
        vertical-align: top;
    }
    .grv-table--small .grv-table__header:first-child {
        padding-left: 0;
    }
    .grv-table--small .grv-table__header:last-child {
        padding-right: 0;
    }
    .grv-table--small .grv-table__header--right-align {
        text-align: right;
    }
    .grv-table--small .grv-table__header--center-align {
        text-align: center;
    }
    .grv-table--small .grv-table__header--left-align {
        text-align: left;
    }
    .grv-table--small .grv-table__body {
        font-family: Optimist, "Helvetica Neue", Helvetica, Arial, sans-serif;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-size: 14px;
        line-height: 1.5;
        font-weight: 400;
    }
    .grv-table--tiny .grv-table__header {
        text-align: left;
        text-transform: uppercase;
        font-family: Optimist, "Helvetica Neue", Helvetica, Arial, sans-serif;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-size: 12px;
        line-height: 1.5;
        font-weight: 600;
        padding: 16px 8px 8px;
        vertical-align: top;
    }
    .grv-table--tiny .grv-table__header:first-child {
        padding-left: 0;
    }
    .grv-table--tiny .grv-table__header:last-child {
        padding-right: 0;
    }
    .grv-table--tiny .grv-table__header--right-align {
        text-align: right;
    }
    .grv-table--tiny .grv-table__header--center-align {
        text-align: center;
    }
    .grv-table--tiny .grv-table__header--left-align {
        text-align: left;
    }
    .grv-table--tiny .grv-table__body {
        font-family: Optimist, "Helvetica Neue", Helvetica, Arial, sans-serif;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-size: 12px;
        line-height: 1.5;
        font-weight: 400;
    }

    .first-row {
        border-color: #0070A8;
        ;
    }

    .long-string {
        overflow-wrap: anywhere;
    }

    a {
        color: #0070A8;
    }
`;
